import CodeBase from "./CodeBase.js"

// 스케줄 상태 코드 정의 클래스

class ScheduleStatus extends CodeBase {

  // 최종정의 : 작성중/대기중/진행중/중지/취소/완료/시스템중지(G)/시스템취소(H)
  // 시스템중지(G),시스템취소(H)는 상태코드 목록에 나오지 않아야 하므로 Map에서는 제외하지만 화면에서는 '중지S','취소S'로 표현한다.
  constructor() {
    const CODE_MAP = {
      'A' : '작성중',
      'B' : '대기중',
      'C' : '진행중',
      'D' : '완료',
      'E' : '중지',
      'F' : '취소',
      };

    super(CODE_MAP);
  }
}

export default ScheduleStatus;
